const AUTH_STORAGE_KEYS = {
  recruiter: {
    token: 'recruiter_token',
    user: 'recruiter_user',
  },
  superadmin: {
    token: 'superadmin_token',
    user: 'superadmin_user',
  },
  candidate: {
    token: 'candidate_token',
    user: 'candidate_user',
  },
};

const RECRUITER_PATHS = ['/recruiter', '/drives', '/candidates', '/sections', '/question-bank', '/exam-management', '/analytics'];
const CANDIDATE_PATHS = ['/dashboard', '/exam', '/result', '/congratulations', '/keep-going'];

export function normalizeUserRole(role) {
  if (role === 'superadmin') return 'superadmin';
  if (['recruiter', 'hr', 'admin', 'junior_recruiter', 'senior_recruiter'].includes(role)) return 'recruiter';
  return 'candidate';
}

export function getRoleFromPathname(pathname = '') {
  if (pathname === '/superadmin' || pathname.startsWith('/superadmin/')) return 'superadmin';
  if (RECRUITER_PATHS.includes(pathname)) return 'recruiter';
  if (CANDIDATE_PATHS.includes(pathname)) return 'candidate';
  return null;
}

function getKeysForRole(role) {
  return AUTH_STORAGE_KEYS[normalizeUserRole(role)] || AUTH_STORAGE_KEYS.candidate;
}

export function getStoredTokenForRole(role) {
  const { token } = getKeysForRole(role);
  return localStorage.getItem(token);
}

export function getStoredUserForRole(role) {
  const { user } = getKeysForRole(role);
  try {
    return JSON.parse(localStorage.getItem(user) || '{}');
  } catch {
    return {};
  }
}

export function getActiveRole(pathname = typeof window !== 'undefined' ? window.location.pathname : '') {
  return getRoleFromPathname(pathname) || 'candidate';
}

export function getActiveToken(pathname = typeof window !== 'undefined' ? window.location.pathname : '') {
  const activeRole = getActiveRole(pathname);
  return getStoredTokenForRole(activeRole) || localStorage.getItem('token');
}

export function setAuthSession(user, tokenValue) {
  const normalizedRole = normalizeUserRole(user?.role);
  const { token, user: userKey } = getKeysForRole(normalizedRole);

  localStorage.setItem(token, tokenValue);
  localStorage.setItem(userKey, JSON.stringify(user));

  // Keep legacy keys for older screens that still read the shared storage.
  localStorage.setItem('token', tokenValue);
  localStorage.setItem('user', JSON.stringify(user));
}

export function clearAuthSession(role) {
  const normalizedRole = normalizeUserRole(role);
  const { token, user } = getKeysForRole(normalizedRole);

  localStorage.removeItem(token);
  localStorage.removeItem(user);

  try {
    const legacyUser = JSON.parse(localStorage.getItem('user') || '{}');
    if (normalizeUserRole(legacyUser?.role) === normalizedRole) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  } catch {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
}
